import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { Button, Table, Select, Modal, DatePicker, Input } from "antd";
import dayjs from "dayjs";
import Layout from "../../Layout";
import CustomerDetailDrawer from "./components/CustomerDetailDrawer";

interface TaskItem {
    key: string;
    level: "Biến chứng" | "Khiếu nại" | "T+24h" | "Nhắc lịch / thẻ" | "Gọi lại khách cũ (A, C)";
    customerCode: string;
    customerName: string;
    phone: string;
    category: "Clinic" | "Newhair" | "PTTM" | "Partnership";
    taskContent: string;
    source: string;
    dueDate: string;
    dueDateUrgent?: boolean;
    dueDateTooltip?: boolean;
    photoStatus: string;
    photoAction?: boolean;
    latestService: string;
    assignee: string;
    preferredChannel: "Gọi" | "Zalo" | "WhatsApp";
    notes?: string;
}

export default function CongViecHangDoiCSKHPage() {
    // State bộ lọc loại công việc
    const [selectedCategory, setSelectedCategory] = useState<string>("Tất cả");

    // State quản lý Drawer chi tiết khách hàng bên phải
    const [selectedCustomer, setSelectedCustomer] = useState<any | null>(null);

    // State trạng thái nhân viên CSKH góc dưới
    const [staffStatus, setStaffStatus] = useState<"available" | "break" | "offline">("available");

    // --- State quản lý Modal + Tạo việc ---
    const [isCreateTaskModalOpen, setIsCreateTaskModalOpen] = useState(false);
    const [modalCustomer, setModalCustomer] = useState("KH-19950 · Chị L.B.T");
    const [modalTaskType, setModalTaskType] = useState("Biến chứng");
    const [modalDueDate, setModalDueDate] = useState<any>(dayjs("2026-10-16 09:00"));
    const [modalAssignee, setModalAssignee] = useState("NV-07");
    const [modalNote, setModalNote] = useState("");

    // Dữ liệu danh sách Công việc chuẩn theo hình
    const [tasksData, setTasksData] = useState<TaskItem[]>([
        {
            key: "1",
            level: "Biến chứng",
            customerCode: "KH-16002",
            customerName: "Chị N.H.A",
            phone: "093***5521",
            category: "Clinic",
            taskContent: "Báo sưng đỏ kéo dài sau buổi 1 phác đồ K·Lift (13/10)",
            source: "Từ tin Zalo hôm nay 08:55 (R27)",
            dueDate: "Ngay — kết nối bác sĩ",
            dueDateUrgent: true,
            photoStatus: "Có ảnh bất thường",
            latestService: "K·Lift buổi 1 · 13/10",
            assignee: "NV-07",
            preferredChannel: "Gọi"
        },
        {
            key: "2",
            level: "Khiếu nại",
            customerCode: "KH-15890",
            customerName: "Anh P.Q.D",
            phone: "090***8813",
            category: "Newhair",
            taskContent: "Khiếu nại thời gian chờ ngày tái khám (KN-0412)",
            source: "Từ cuộc gọi đến 14/10 09:48 · CS-04",
            dueDate: "Quá 1 ngày",
            dueDateUrgent: true,
            dueDateTooltip: true,
            photoStatus: "Đủ ảnh T+30",
            latestService: "Tái khám sau cấy · 13/10",
            assignee: "NV-07",
            preferredChannel: "Gọi"
        },
        {
            key: "3",
            level: "T+24h",
            customerCode: "KH-17311",
            customerName: "Chị H.T.M",
            phone: "090***0928",
            category: "Clinic",
            taskContent: "T+24h sau buổi 1 phác đồ K·Lift",
            source: "Tự động · POS 14/10 (R10)",
            dueDate: "Còn 3 giờ",
            photoStatus: "Chưa có ảnh T+24h",
            photoAction: true,
            latestService: "K·Lift buổi 1 · 14/10",
            assignee: "NV-07",
            preferredChannel: "Zalo"
        },
        {
            key: "4",
            level: "T+24h",
            customerCode: "KH-14421",
            customerName: "Anh L.V.T",
            phone: "098***2204",
            category: "Newhair",
            taskContent: "T+24h sau buổi cấy tóc",
            source: "Tự động · POS 14/10 (R10)",
            dueDate: "Còn 5 giờ",
            photoStatus: "Chưa có ảnh T+24h",
            photoAction: true,
            latestService: "Cấy tóc · 14/10",
            assignee: "NV-07",
            preferredChannel: "Zalo"
        },
        {
            key: "5",
            level: "Nhắc lịch / thẻ",
            customerCode: "KH-18050",
            customerName: "Chị B.T.H",
            phone: "093***4470",
            category: "PTTM",
            taskContent: "Nhắc tái khám cắt chỉ 17/10 (T+7 sau phẫu thuật) — chưa xác nhận",
            source: "Tự động · lịch 17/10 chưa xác nhận",
            dueDate: "Hôm nay",
            photoStatus: "Đủ ảnh T+3",
            latestService: "Phẫu thuật mắt · 10/10",
            assignee: "NV-08",
            preferredChannel: "Zalo"
        },
        {
            key: "6",
            level: "Nhắc lịch / thẻ",
            customerCode: "KH-12087",
            customerName: "Chị Đ.T.L",
            phone: "091***4436",
            category: "Clinic",
            taskContent: "Thẻ còn 2 buổi · hạn 30/11 — xác nhận lịch 20/10",
            source: "Tự động · thẻ còn 46 ngày hết hạn",
            dueDate: "Trong tuần",
            photoStatus: "Đủ ảnh T+30",
            latestService: "K·Renewal buổi 3 · 28/07",
            assignee: "NV-07",
            preferredChannel: "Zalo"
        },
        {
            key: "7",
            level: "Nhắc lịch / thẻ",
            customerCode: "KH-19950",
            customerName: "Chị L.B.T",
            phone: "+61 4*** *** 118",
            category: "Clinic",
            taskContent: "Khách cũ giữ chỗ lịch 18/12 — nhắc cọc khi chốt vé",
            source: "Tự động · lịch 18/12 chờ cọc",
            dueDate: "Trong tuần",
            photoStatus: "—",
            latestService: "K·Reskin · 20/12/2025",
            assignee: "NV-07",
            preferredChannel: "WhatsApp",
            notes: "Telesales đã chạm hôm nay (R22) · R22/R26: cả gọi và nhắn"
        },
        {
            key: "8",
            level: "Gọi lại khách cũ (A, C)",
            customerCode: "KH-13377",
            customerName: "Chị M.T.K",
            phone: "094***1187",
            category: "Clinic",
            taskContent: "Gọi lại nhóm C — chưa có thẻ thành viên",
            source: "Tự động · CS3 quá 60 ngày (R10)",
            dueDate: "Trong tuần",
            photoStatus: "Thiếu ảnh T+30",
            latestService: "Dịch vụ lẻ da · 05/08",
            assignee: "NV-08",
            preferredChannel: "Zalo",
            notes: "Chỉ nhắn Zalo"
        }
    ]);

    // Logic xử lý khi nhấn nút "Tạo việc" trong Modal
    const handleCreateTask = () => {
        const selectedCode = modalCustomer.split(" · ")[0] || "KH-19950";
        const selectedName = modalCustomer.split(" · ")[1] || "Chị L.B.T";

        const newTask: TaskItem = {
            key: Date.now().toString(),
            level: (modalTaskType === "Biến chứng" ? "Biến chứng" : modalTaskType === "Khiếu nại" ? "Khiếu nại" : "Nhắc lịch / thẻ") as any,
            customerCode: selectedCode,
            customerName: selectedName,
            phone: "090***9999",
            category: "Clinic",
            taskContent: modalNote || `${modalTaskType} — Tạo tay`,
            source: "Tạo tay · NV-07",
            dueDate: modalDueDate ? modalDueDate.format("MM/DD/YYYY HH:mm") : "Hôm nay",
            dueDateUrgent: modalTaskType === "Biến chứng" || modalTaskType === "Khiếu nại",
            photoStatus: "—",
            latestService: "Dịch vụ mới",
            assignee: modalAssignee,
            preferredChannel: "Gọi"
        };

        setTasksData([newTask, ...tasksData]);
        alert(`Đã tạo công việc "${modalTaskType}" cho khách hàng ${selectedCode} thành công!`);
        setIsCreateTaskModalOpen(false);
        setModalNote("");
    };

    // Logic Lọc dữ liệu dựa trên nút filter được chọn
    const filteredTasks = tasksData.filter((task) => {
        if (selectedCategory === "Tất cả") return true;
        if (selectedCategory === "Biến chứng" && task.level === "Biến chứng") return true;
        if (selectedCategory === "Khiếu nại" && task.level === "Khiếu nại") return true;
        if (selectedCategory === "T+24h" && task.level === "T+24h") return true;
        if (selectedCategory === "Nhắc lịch / thẻ" && task.level === "Nhắc lịch / thẻ") return true;
        if (selectedCategory === "Gọi lại khách cũ (A, C)" && task.level.includes("Gọi lại khách cũ")) return true;
        return false;
    });

    // Cấu hình cột hiển thị cho Bảng
    const columns = [
        {
            title: "Mức",
            key: "level",
            width: "110px",
            render: (_: any, record: TaskItem) => {
                let badgeStyle = "bg-blue-600 text-white";
                if (record.level === "Biến chứng") badgeStyle = "bg-[#a61c1c] text-white font-bold";
                else if (record.level === "Khiếu nại") badgeStyle = "bg-[#d97706] text-white font-bold";
                else if (record.level === "T+24h") badgeStyle = "bg-[#1d4c7d] text-white font-bold";
                else if (record.level === "Nhắc lịch / thẻ") badgeStyle = "bg-[#2b6cb0] text-white font-bold";
                else if (record.level.includes("Gọi lại khách cũ")) badgeStyle = "bg-[#4a5568] text-white font-bold";

                return (
                    <span className={`px-2 py-1 rounded text-[11px] inline-block text-center w-full ${badgeStyle}`}>
                        {record.level}
                    </span>
                );
            }
        },
        {
            title: "Khách",
            key: "customer",
            width: "140px",
            render: (_: any, record: TaskItem) => (
                <span
                    onClick={() => {
                        setSelectedCustomer({
                            code: record.customerCode,
                            name: record.customerName,
                            phone: record.phone,
                            serviceCategory: record.category,
                            csCode: "CS2"
                        });
                    }}
                    className="font-medium text-[#1d4c7d] dark:text-blue-400 cursor-pointer hover:underline block leading-tight"
                >
                    {record.customerCode} · {record.customerName}
                </span>
            )
        },
        {
            title: "Mảng",
            dataIndex: "category",
            key: "category",
            width: "65px",
            render: (text: string) => <span className="text-gray-700 dark:text-gray-300">{text}</span>
        },
        {
            title: "Việc",
            dataIndex: "taskContent",
            key: "taskContent",
            width: "220px",
            render: (text: string) => <span className="text-gray-900 dark:text-gray-100 font-medium leading-snug">{text}</span>
        },
        {
            title: "Nguồn",
            dataIndex: "source",
            key: "source",
            width: "150px",
            render: (text: string) => <span className="text-gray-600 dark:text-gray-400 text-[11px]">{text}</span>
        },
        {
            title: "Hạn",
            key: "dueDate",
            width: "110px",
            render: (_: any, record: TaskItem) => (
                <div className="flex items-center gap-1">
                    <span className={record.dueDateUrgent ? "text-red-600 font-bold" : "text-gray-800 dark:text-gray-200"}>
                        {record.dueDate}
                    </span>
                    {record.dueDateTooltip && (
                        <span className="bg-[#d97706] text-white text-[10px] px-1 py-0.2 rounded font-bold cursor-pointer">[?]</span>
                    )}
                </div>
            )
        },
        {
            title: "Ảnh mốc",
            key: "photoStatus",
            width: "120px",
            render: (_: any, record: TaskItem) => (
                <div className="space-y-0.5">
                    {record.photoStatus.includes("bất thường") ? (
                        <span className="text-red-600 font-bold">{record.photoStatus}</span>
                    ) : record.photoStatus.includes("Đủ ảnh") ? (
                        <span className="text-green-700 dark:text-green-400 font-medium">{record.photoStatus}</span>
                    ) : record.photoStatus.includes("Thiếu ảnh") ? (
                        <span className="text-red-500 font-medium">{record.photoStatus}</span>
                    ) : record.photoStatus.includes("Chưa có ảnh") ? (
                        <div className="space-y-0.5">
                            <span className="text-red-600 font-medium">{record.photoStatus}</span>
                            {record.photoAction && (
                                <button className="text-[10px] bg-white border border-gray-300 rounded px-1.5 py-0.2 hover:bg-gray-50 text-gray-700 block">
                                    Xin ảnh
                                </button>
                            )}
                        </div>
                    ) : (
                        <span className="text-gray-400">{record.photoStatus}</span>
                    )}
                </div>
            )
        },
        {
            title: "SĐT",
            dataIndex: "phone",
            key: "phone",
            width: "100px",
            render: (text: string) => <span className="text-gray-700 dark:text-gray-300 font-mono text-[11px]">{text}</span>
        },
        {
            title: "Dịch vụ gần nhất",
            dataIndex: "latestService",
            key: "latestService",
            width: "130px",
            render: (text: string) => <span className="text-gray-700 dark:text-gray-300">{text}</span>
        },
        {
            title: "Phụ trách",
            dataIndex: "assignee",
            key: "assignee",
            width: "60px",
            render: (text: string) => <span className="text-gray-700 dark:text-gray-300 font-medium">{text}</span>
        },
        {
            title: "Thao tác",
            key: "actions",
            width: "170px",
            render: (_: any, record: TaskItem) => (
                <div className="space-y-1">
                    <div className="flex items-center gap-1">
                        {record.preferredChannel === "WhatsApp" && (
                            <>
                                <Button size="small" type="primary" className="!bg-[#1d4c7d] text-xs h-6 px-2 font-bold">
                                    WhatsApp
                                </Button>
                                <Button size="small" disabled className="text-xs h-6 px-2 text-gray-400 bg-gray-100">
                                    Gọi
                                </Button>
                            </>
                        )}
                        {record.preferredChannel === "Gọi" && (
                            <>
                                <Button size="small" type="primary" className="!bg-[#1d4c7d] text-xs h-6 px-2.5 font-bold">
                                    Gọi
                                </Button>
                                <Button size="small" className="text-xs h-6 px-2.5 border-gray-300">
                                    Zalo
                                </Button>
                            </>
                        )}
                        {record.preferredChannel === "Zalo" && (
                            <>
                                <Button size="small" type="primary" className="!bg-[#1d4c7d] text-xs h-6 px-2.5 font-bold">
                                    Zalo
                                </Button>
                                <Button size="small" className="text-xs h-6 px-2.5 border-gray-300">
                                    Gọi
                                </Button>
                            </>
                        )}
                    </div>

                    {record.notes && (
                        <div className="text-[10px] text-red-600 leading-tight">
                            {record.notes.includes("Telesales") && (
                                <div>
                                    Telesales đã chạm hôm nay (R22) <span className="bg-[#3E91AB] text-white px-1 rounded">Zalo</span>
                                </div>
                            )}
                            <div>{record.notes}</div>
                        </div>
                    )}
                </div>
            )
        }
    ];

    const getStatusDotColor = () => {
        switch (staffStatus) {
            case "available": return "#52c41a";
            case "break": return "#d48806";
            case "offline": return "#8c8c8c";
            default: return "#52c41a";
        }
    };

    return (
        <Layout>
            <Helmet>
                <title>Công việc — hàng đợi chăm sóc | Khothi</title>
            </Helmet>

            <div className="min-h-screen text-xs flex flex-col justify-between transition-colors duration-200">
                <div className="flex flex-1 overflow-hidden gap-4">
                    
                    {/* KHUNG NỘI DUNG CHÍNH BÊN TRÁI */}
                    <div className="space-y-3 overflow-y-auto pb-20 w-full">
                        
                        {/* 1. Header Tiêu đề Công việc */}
                        <div className="flex flex-wrap items-center justify-between border-b border-gray-200 dark:border-gray-800 pb-2 gap-2">
                            <div className="flex flex-wrap items-center gap-2 sm:gap-3 border-l-4 border-[#1d4c7d] pl-2">
                                <span className="font-bold text-[#1d4c7d] dark:text-blue-400 text-sm">
                                    Công việc — hàng đợi chăm sóc
                                </span>
                                <span className="text-gray-600 dark:text-gray-400">
                                    Vai trò: CSKH
                                </span>
                                <span className="text-gray-500 dark:text-gray-400 hidden xl:inline">
                                    Quy tắc: Xếp: biến chứng → khiếu nại → T+24h → nhắc lịch / thẻ → gọi lại khách cũ (A, C) · R04 · R10 · R11 · R19 · R20 · R22 · mã CS-01...08
                                </span>
                            </div>
                        </div>

                        {/* 2. Dòng Khung Cam DỮ LIỆU MINH HOẠ */}
                        <div className="border border-dashed border-orange-400 bg-orange-50 dark:bg-orange-950/30 text-orange-700 dark:text-orange-400 text-center py-1 font-bold tracking-wider rounded text-xs">
                            DỮ LIỆU MINH HOẠ — tên khách, mã nhân viên và mọi con số là giả
                        </div>

                        {/* 3. Dòng chú thích nguồn việc & Nút + Tạo việc */}
                        <div className="flex items-center justify-between gap-2 pt-1">
                            <span className="text-gray-600 dark:text-gray-400 text-[11px]">
                                Việc tự sinh theo quy tắc hoặc tạo tay — không phụ thuộc kênh (mục 2.6). Cột Nguồn cho biết việc sinh ra từ đâu.
                            </span>
                            <Button 
                                type="primary"
                                onClick={() => setIsCreateTaskModalOpen(true)}
                                className="!bg-[#1d4c7d] text-xs font-bold h-7 px-3"
                            >
                                + Tạo việc
                            </Button>
                        </div>

                        {/* 4. Thanh Bộ Lọc Loại Công Việc */}
                        <div className="flex flex-wrap items-center gap-2 pt-1">
                            {[
                                "Tất cả",
                                "Biến chứng",
                                "Khiếu nại",
                                "T+24h",
                                "Nhắc lịch / thẻ",
                                "Gọi lại khách cũ (A, C)"
                            ].map((filterName) => {
                                const isActive = selectedCategory === filterName;
                                return (
                                    <button
                                        key={filterName}
                                        onClick={() => setSelectedCategory(filterName)}
                                        className={`px-3 py-1 rounded-full border text-xs font-medium transition-all ${
                                            isActive
                                                ? "bg-[#1d4c7d] text-white border-[#1d4c7d] shadow-sm font-bold"
                                                : "bg-white dark:bg-[#1f1f1f] text-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-700 hover:bg-gray-100"
                                        }`}
                                    >
                                        {filterName}
                                    </button>
                                );
                            })}
                        </div>

                        {/* 5. Bảng Danh Sách Công Việc */}
                        <div className="bg-white dark:bg-[#1f1f1f] rounded border border-gray-200 dark:border-gray-800 shadow-sm overflow-hidden mt-2">
                            <Table
                                columns={columns}
                                dataSource={filteredTasks}
                                pagination={false}
                                size="small"
                                className="custom-task-queue-table"
                                scroll={{ x: "max-content" }}
                                rowClassName={(record, index) =>
                                    index % 2 === 1
                                        ? "bg-slate-50/80 dark:bg-[#252525]"
                                        : "bg-white dark:bg-[#1f1f1f]"
                                }
                            />
                        </div>

                    </div>

                    {/* 6. DRAWER CHI TIẾT KHÁCH HÀNG BÊN PHẢI */}
                    {selectedCustomer && (
                        <CustomerDetailDrawer
                            customer={selectedCustomer}
                            onClose={() => setSelectedCustomer(null)}
                        />
                    )}
                </div>

                {/* Floating Widget Thanh Trạng Thái (PC 1 hàng, Mobile tự động xuống 2 hàng) */}
                <div className="sticky bottom-3 z-27 sm:mx-0 bg-[#1d4c7d] dark:bg-[#142f4c] text-white rounded-lg shadow-xl px-3.5 py-2.5 flex flex-col sm:flex-row items-center justify-between sm:justify-start gap-2 sm:gap-3 w-full sm:w-fit border border-[#3E91AB]">
                    
                    {/* Phần thông tin nhân viên và Select trạng thái */}
                    <div className="flex items-center justify-between sm:justify-start w-full sm:w-auto gap-2">
                        <div className="flex items-center gap-2">
                            <span
                                className="w-2.5 h-2.5 rounded-full inline-block flex-shrink-0"
                                style={{ backgroundColor: getStatusDotColor() }}
                            ></span>
                            <span className="font-bold text-sm whitespace-nowrap">
                                NV-07 · CSKH
                            </span>
                        </div>

                        {/* Trên mobile hiển thị Select ở đây cho cân đối dòng 1 */}
                        <div className="block sm:hidden">
                            <Select
                                size="small"
                                value={staffStatus}
                                onChange={(val) => setStaffStatus(val)}
                                className="w-[110px] text-sm flex-shrink-0"
                                options={[
                                    { label: "Sẵn sàng", value: "available" },
                                    { label: "Tạm nghỉ", value: "break" },
                                    { label: "Ngoại tuyến", value: "offline" },
                                ]}
                            />
                        </div>
                    </div>

                    {/* Phần Select (cho PC) và các nút bấm hành động */}
                    <div className="flex items-center justify-between sm:justify-start gap-2 w-full sm:w-auto border-t border-blue-400/30 pt-2 sm:border-t-0 sm:pt-0">
                        
                        {/* Trên PC hiển thị Select ở vị trí này */}
                        <div className="hidden sm:block">
                            <Select
                                size="small"
                                value={staffStatus}
                                onChange={(val) => setStaffStatus(val)}
                                className="w-[125px] text-sm flex-shrink-0"
                                options={[
                                    { label: "Sẵn sàng", value: "available" },
                                    { label: "Tạm nghỉ", value: "break" },
                                    { label: "Ngoại tuyến", value: "offline" },
                                ]}
                            />
                        </div>

                        <span className="text-xs text-gray-200 hidden md:inline whitespace-nowrap">
                            Không có cuộc gọi
                        </span>

                        <div className="flex items-center gap-1.5 w-full sm:w-auto justify-end">
                            <Button
                                size="small"
                                className="bg-white text-gray-800 hover:bg-gray-100 font-medium text-xs border-0 h-7 px-2.5 flex-1 sm:flex-initial"
                            >
                                Mô phỏng gọi đến
                            </Button>

                            <Button
                                size="small"
                                className="bg-white text-gray-800 hover:bg-gray-100 font-medium text-xs border-0 h-7 px-2.5 flex-1 sm:flex-initial"
                            >
                                Gọi số mới
                            </Button>
                        </div>
                    </div>
                </div>

                {/* MODAL + TẠO VIỆC (CÔNG VIỆC CSKH) CHUẨN XÁC THEO HÌNH MẪU */}
                <Modal
                    title={<div className="font-bold text-[#1d4c7d] text-sm">+ Tạo việc (Công việc CSKH)</div>}
                    open={isCreateTaskModalOpen}
                    onCancel={() => setIsCreateTaskModalOpen(false)}
                    footer={null}
                    width={460}
                    centered
                >
                    <div className="space-y-3 pt-2 text-xs">
                        {/* Chọn Khách */}
                        <div className="flex items-center gap-3">
                            <span className="font-medium text-gray-700 dark:text-gray-300 w-20 flex-shrink-0">Khách</span>
                            <Select
                                value={modalCustomer}
                                onChange={(val) => setModalCustomer(val)}
                                className="w-full text-xs"
                                options={[
                                    { label: "KH-19950 · Chị L.B.T", value: "KH-19950 · Chị L.B.T" },
                                    { label: "KH-16002 · Chị N.H.A", value: "KH-16002 · Chị N.H.A" },
                                    { label: "KH-15890 · Anh P.Q.D", value: "KH-15890 · Anh P.Q.D" },
                                    { label: "KH-17311 · Chị H.T.M", value: "KH-17311 · Chị H.T.M" },
                                    { label: "KH-14421 · Anh L.V.T", value: "KH-14421 · Anh L.V.T" },
                                ]}
                            />
                        </div>

                        {/* Loại việc */}
                        <div className="flex items-center gap-3">
                            <span className="font-medium text-gray-700 dark:text-gray-300 w-20 flex-shrink-0">Loại việc</span>
                            <Select
                                value={modalTaskType}
                                onChange={(val) => setModalTaskType(val)}
                                className="w-full text-xs"
                                options={[
                                    { label: "Biến chứng", value: "Biến chứng" },
                                    { label: "Khiếu nại", value: "Khiếu nại" },
                                    { label: "Gọi lại khách cũ", value: "Gọi lại khách cũ" },
                                    { label: "Đặt lịch tái khám", value: "Đặt lịch tái khám" },
                                    { label: "Nhắc thanh toán", value: "Nhắc thanh toán" },
                                ]}
                            />
                        </div>

                        {/* Hạn */}
                        <div className="flex items-center gap-3">
                            <span className="font-medium text-gray-700 dark:text-gray-300 w-20 flex-shrink-0">Hạn</span>
                            <DatePicker 
                                showTime
                                format="MM/DD/YYYY hh:mm A"
                                value={modalDueDate}
                                onChange={(date) => setModalDueDate(date)}
                                className="w-full text-xs"
                            />
                        </div>

                        {/* Người nhận */}
                        <div className="flex items-center gap-3">
                            <span className="font-medium text-gray-700 dark:text-gray-300 w-20 flex-shrink-0">Người nhận</span>
                            <Select
                                value={modalAssignee}
                                onChange={(val) => setModalAssignee(val)}
                                className="w-full text-xs"
                                options={[
                                    { label: "NV-07", value: "NV-07" },
                                    { label: "NV-01", value: "NV-01" },
                                    { label: "NV-08", value: "NV-08" },
                                    { label: "Quản lý CSKH", value: "Quản lý CSKH" },
                                ]}
                            />
                        </div>

                        {/* Ghi chú */}
                        <div className="flex items-start gap-3">
                            <span className="font-medium text-gray-700 dark:text-gray-300 w-20 flex-shrink-0 pt-1">Ghi chú</span>
                            <Input.TextArea
                                rows={2}
                                placeholder="Không ghi chi tiết bệnh lý"
                                value={modalNote}
                                onChange={(e) => setModalNote(e.target.value)}
                                className="w-full text-xs"
                            />
                        </div>

                        {/* Nút thao tác */}
                        <div className="flex justify-end gap-2 pt-2">
                            <Button 
                                onClick={() => setIsCreateTaskModalOpen(false)}
                                className="text-xs h-8 px-4"
                            >
                                Huỷ
                            </Button>
                            <Button 
                                type="primary"
                                onClick={handleCreateTask}
                                className="!bg-[#1d4c7d] text-xs h-8 px-4 font-bold"
                            >
                                Tạo việc
                            </Button>
                        </div>

                        {/* Chú thích phía dưới Modal */}
                        <div className="text-[11px] text-gray-500 pt-2 border-t border-gray-100 dark:border-gray-800 leading-relaxed">
                            Việc tạo tay ghi nguồn "Tạo tay · người tạo" và một dòng Lịch sử chạm.<br />
                            Biến chứng / Khiếu nại tạo tay cũng gắn cờ lên hồ sơ.
                        </div>
                    </div>
                </Modal>
            </div>
        </Layout>
    );
}